import reportError from '@shared/reportError';
import {
  ErrorBoundaryPropsWithFallback,
  ErrorBoundary as ReactErrorBoundary,
} from 'react-error-boundary';

const ErrorBoundary = ({ onError, ...rest }: ErrorBoundaryPropsWithFallback) => (
  <ReactErrorBoundary
    onError={
      onError
        ? (...args) => {
            onError(...args);
            reportError(...args);
          }
        : reportError
    }
    {...rest}
  />
);

export default ErrorBoundary;
